import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    paddingTop: indent * 5,
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    top: indent * 3,
    right: indent,
    width: 40,
    height: 40,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
  },
  closeButtonText: {
    color: white,
    fontSize: 20,
    fontWeight: 'bold',
  },
  title: {
    fontSize: 32,
    color: white,
    marginBottom: indent,
    paddingTop: 12,
  },
  subtitle: {
    fontSize: 18,
    color: '#fff',
    textAlign: 'center',
    marginHorizontal: 30,
    marginBottom: indent * 2,
    lineHeight: 24,
  },
  button: {
    backgroundColor: '#fff',
    paddingVertical: 12,
    paddingHorizontal: 30,
    borderRadius: 10,
    elevation: 3,
  },
  buttonText: {
    color: '#2A9D8F',
    fontSize: 16,
  },
});
